export default `{
  "js_snippet": "window.scrollTo(0,document.body.scrollHeight);"
}`